import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

export const ApiErrorAlert = (messages: string[]) => {
  const sAlert = withReactContent(Swal);

  // Render messages for sweet alert
  const renderError = () => {
    const element = document.createElement("div");
    messages.forEach((message) => {
      element.innerHTML += `
        <div>${message}</div>
      `;
    });

    return element;
  };

  sAlert.fire({
    title: renderError(),
    confirmButtonText: "تایید",
  });
};
